import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Navbar } from "@/components/Navbar";
import { StatusBadge } from "@/components/StatusBadge";
import { api } from "@/lib/api";

import {
  FinalPrescriptionSection,
  PaymentPendingBanner,
  PaymentRejectedBanner,
  RemindersSection,
  RequestInfoCard,
  RequestTimeline,
} from "./RequestSections";

/** Carga la solicitud con polling cada 20s y los recordatorios al completarse. */
function useRequestData(id) {
  const [req, setReq] = useState(null);
  const [reminders, setReminders] = useState([]);

  useEffect(() => {
    const load = () => api.get(`/requests/${id}`).then((r) => setReq(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [id]);

  useEffect(() => {
    if (req?.status === "completed") {
      api.get(`/requests/${id}/reminders`).then((r) => setReminders(r.data)).catch(() => {});
    }
  }, [id, req?.status]);

  return { req, reminders };
}

export default function RequestView() {
  const { id } = useParams();
  const { req, reminders } = useRequestData(id);

  if (!req)
    return (
      <div className="min-h-screen bg-background">
        <Navbar />
        <div className="flex justify-center py-24">
          <Loader2 className="h-8 w-8 animate-spin text-primary" strokeWidth={1.5} />
        </div>
      </div>
    );

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="request-view-page">
        <div className="flex flex-wrap items-center justify-between gap-3 mb-8">
          <div>
            <p className="text-sm text-muted-foreground uppercase tracking-widest mb-1">Solicitud de receta</p>
            <h1 className="text-2xl sm:text-3xl font-bold">
              {req.folio ? `Folio ${req.folio}` : "Receta THAG"}
            </h1>
          </div>
          <StatusBadge status={req.status} />
        </div>

        <PaymentRejectedBanner req={req} />
        <PaymentPendingBanner req={req} />
        <RequestTimeline status={req.status} />
        <RequestInfoCard req={req} />
        <RemindersSection req={req} reminders={reminders} />
        <FinalPrescriptionSection req={req} />
      </main>
    </div>
  );
}
